import { useEffect, useRef, useState } from "react"
import { Col, Row } from "react-bootstrap"
import SkillComponent from "./Skill"
import SkillLoader from "./SkillLoader"
import { PublicSkillsQuery, usePublicSkillsQuery } from "@generated/graphql"
import useIntersectionObserver from "@utils/useIntersectionObserver"

interface IPublicSkillList {
  skills: PublicSkillsQuery["publicSkills"]
}

export default function PublicSkillList({ skills }: IPublicSkillList) {
  const loadMoreRef = useRef<HTMLDivElement>(null)
  const [skip, setSkip] = useState<number>(skills.length)
  const TAKE = 3
  const entry = useIntersectionObserver(loadMoreRef, {})
  const [localSkills, setLocalSkills] = useState<PublicSkillsQuery["publicSkills"]>(skills)

  const { data: skillData, loading: skillsLoading, error } = usePublicSkillsQuery({
    variables: {
      take: TAKE,
      skip: skip
    },
    fetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true
  })

  useEffect(() => {
    if ((entry === undefined || entry?.isIntersecting === true) && (localSkills.length % 3 === 0)) {
      setSkip(localSkills.length)
    }
  }, [localSkills.length, entry])

  useEffect(() => {
    if (skillData && skillData.publicSkills) {
      setLocalSkills([...localSkills, ...skillData.publicSkills])
    }
  }, [skillData])

  return <Row>
    {localSkills?.map((skill, index) =>
      <Col lg={4} sm={6} key={index} className="bg-white">
        <SkillComponent skill={skill} />
      </Col>
    )}
    {skillsLoading && <SkillLoader count={3} />}
    <span ref={loadMoreRef}></span>
  </Row>
}
